<template>
    <base-circular-new pagetitle="Produtos" :step="2" title="Escolha os produtos" subtitle="Escolha os produtos que irá utilizar para criar sua nova circular.">
        <div class="row" v-for="i in qtd_itens" :key="i">
            <div class="col s12">
                <div class="card-panel grey lighten-5">
                    <div class="row">
                        <div class="col s12">
                            <autocomplete :placeholder="'Produto ' + i" :items="products" @selected="(item) => itemSelected(item, i)" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                        <div class="input-field">
                            <money :id="'sight_price_' + i" :placeholder="products_to_send[i].sight_price" v-model="products_to_send[i].sight_price" v-bind="money"></money>
                            <label :for="'sight_price' + i">Preço à vista</label>
                            <span class="helper-text" data-error="wrong" data-success="right">Preço à vista do produto</span>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                        <div class="input-field">
                            <money :id="'forward_price_'+ i" v-model="products_to_send[i].forward_price" v-bind="money" @input="() => calculatePaymentPrice(i)"></money>
                            <label :for="'forward_price_'+ i">Preço à prazo</label>
                            <span class="helper-text" data-error="wrong" data-success="right">Preço à prazo do produto</span>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                        <div class="input-field">
                            <input :id="'payment_x_'+ i" type="text" class="" v-model="products_to_send[i].payment_x" @input="() => calculatePaymentPrice(i)">
                            <label :for="'payment_x_'+ i">Qtd. Parcelas</label>
                            <span class="helper-text" data-error="wrong" data-success="right">Quantidade de parcelas para pagamento</span>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                        <div class="input-field">
                            <money :id="'payment_price_'+ i" v-model="products_to_send[i].payment_price" v-bind="money" ></money>
                            <label :for="'payment_price_'+ i">Valor da Parcela</label>
                            <span class="helper-text" data-error="wrong" data-success="right">Valor a ser pago por cada parcela</span>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s6">
                            <p>
                                <label>
                                    <input type="checkbox" v-model="products_to_send[i].without_entrance" />
                                    <span>Sem entrada</span>
                                </label>
                            </p>
                        </div>
                        <div class="col s6">
                            <p>
                                <label>
                                    <input type="checkbox" v-model="products_to_send[i].without_interest" @change="calculateWithoutInterest($event, i)" />
                                    <span>Sem juros</span>
                                </label>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s6">
                            <p>
                                <label>
                                    <input type="checkbox" v-model="products_to_send[i].in_carne" />
                                    <span>No carnê</span>
                                </label>
                            </p>
                        </div>

                        <div class="col s6">
                            <p>
                                <label>
                                    <input type="checkbox" v-model="products_to_send[i].in_card" />
                                    <span>No cartão</span>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <button @click="nextStep" class="waves-effect waves-light btn">Próximo!</button>
            </div>
        </div>
    </base-circular-new>
</template>

<script>
import Autocomplete from "../shared/autocomplete/Autocomplete.vue";
import BaseCircularNew from "../shared/base_circular_new/BaseCircularNew.vue";

import {Money} from 'v-money'

import { BASE_URL_API } from "../../config.js";

export default {
    name: 'choice_products',
    components: {
        "base-circular-new": BaseCircularNew,
        "autocomplete": Autocomplete,
        Money
    },
    data() {
        return {
            qtd_itens: 0,
            products: [],
            products_to_send: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false /* doesn't work with directive */
            }
        }
    },
    created() {
        if (Number(this.$route.params.id_template) === 1) {
            this.qtd_itens = 2;
        } else if (Number(this.$route.params.id_template) === 2) {
            this.qtd_itens = 3;
        } else if (Number(this.$route.params.id_template) === 3) {
            this.qtd_itens = 4;
        } else if (Number(this.$route.params.id_template) === 4) {
            this.qtd_itens = 5;
        } else if (Number(this.$route.params.id_template) === 5) {
            this.qtd_itens = 6;
        } else if (Number(this.$route.params.id_template) === 6) {
            this.qtd_itens = 7;
        } else if (Number(this.$route.params.id_template) === 7) {
            this.qtd_itens = 8;
        } else if (Number(this.$route.params.id_template) === 8) {
            this.qtd_itens = 9;
        }

        for (let v = 1; v <= this.qtd_itens; v++) {
            this.products_to_send[v] = {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                code: null,
                features: "",
                without_entrance: false,
                without_interest: false,
                in_carne: false,
                in_card: false
            }
        }
    },
    mounted() {
        const token = localStorage.getItem("user-token");

        this.$http.get(BASE_URL_API + '/products', { params: { token } }).then(response => {
            response.json().then(json => {
                console.log(json)
                this.products = json;
            });
        }, response => {
            // error callback
            response.json().then(ret => {
                if (ret.error)
                    if (ret.error === "Token expirado.") {
                        window.localStorage.removeItem("user-token");
                        this.$router.push('/login');
                    }
            });
        });
    },
    methods: {
        // Chama quando o item é selecionado no autocomplete e preenche todos os dados do produto.
        itemSelected(item, index) {
            this.products_to_send[index].name = item.name;
            this.products_to_send[index].id = item.id;
            this.products_to_send[index].price = Number(item.preco).toFixed(2);
            this.products_to_send[index].sight_price = Number(item.preco).toFixed(2);
            this.products_to_send[index].forward_price = (((Number(item.preco) / 100) * 10) + Number(item.preco)).toFixed(2);
            this.products_to_send[index].payment_x = 10;
            this.products_to_send[index].payment_price = (this.products_to_send[index].forward_price / this.products_to_send[index].payment_x).toFixed(2);
            this.products_to_send[index].code = item.codigo;
            this.products_to_send[index].features = item.caracteristicas;

            this.$forceUpdate();
        },
        // Gera a circular final
        nextStep() {
            var filtered = this.products_to_send.filter(function (el) {
                if (el != null) {
                    if (el.without_entrance)
                        el.payment_x = "0+" + el.payment_x;
                    else
                        el.payment_x = "1+" + (parseInt(el.payment_x) - 1);

                    return true;
                } else {
                    return false;
                }
                return el != null;
            });
            console.log(filtered);
            this.$router.push({
                name: 'opcoes_circular',
                params: {
                    items: filtered,
                    qtd_itens: this.qtd_itens
                }
            });
        },
        // Calcula o valor da parcela ao digita um novo valor a prazo ou ao digitar uma nova quantidade de parcelas
        calculatePaymentPrice(index) {
            this.products_to_send[index].payment_price = (this.products_to_send[index].forward_price / this.products_to_send[index].payment_x).toFixed(2);
            this.$forceUpdate();
        },
        // Calcula o valor à prazo ao digitar um novo valor de parcela
        calculateForwardPrice(index) {
            this.products_to_send[index].forward_price = (this.products_to_send[index].payment_price * this.products_to_send[index].payment_x).toFixed(2);
            this.$forceUpdate();
        },
        // Recalcula o valor ao selecionar sem juros
        calculateWithoutInterest(e, index) {
            if (e.target.checked) {
                this.products_to_send[index].forward_price = Number(this.products_to_send[index].sight_price).toFixed(2);
                this.$forceUpdate();
            } else {
                this.products_to_send[index].forward_price = (((Number(this.products_to_send[index].price) / 100) * this.products_to_send[index].payment_x) + Number(this.products_to_send[index].price)).toFixed(2);
                this.$forceUpdate();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>





// WEBPACK FOOTER //
// src/components/choice_products/ChoiceProducts.vue